import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button, Flex, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { OrganizationOverviewCard } from '~/app/components/organization/OrganizationOverviewCard';
import { organizationTabList } from '~/app/components/organization/OrganizationTabList';
import { OrganizationTabs } from '~/app/components/organization/OrganizationTabs';
import { TriggerIziviaMonprojetCasesButton } from '~/app/components/organization/TriggerIziviaMonprojetCasesButton/TriggerIziviaMonprojetCasesButton';
import { TriggerIziviaMonprojetWorkOrdersButton } from '~/app/components/organization/TriggerIziviaMonprojetWorkOrdersButton/TriggerIziviaMonprojetWorkOrdersButton';
import type { OrganizationPageViewProps } from './OrganizationPage.types';
import { ManagersTabPageContainer } from './managers/ManagersTabPageContainer';
import { SupervisorsTabPageContainer } from './supervisors/SupervisorsTabPageContainer';
import { TechniciansTabPageContainer } from './technicians/TechniciansTabPageContainer';
import { ParksTabPageContainer } from './parks/ParksTabPageContainer';
import { TagsTabPageContainer } from './tags/TagsTabPageContainer';

export function OrganizationPageView({
  activeTab,
  onBack,
  onTabChange,
  organization,
}: OrganizationPageViewProps) {
  const { t } = useTranslation('organization');

  return (
    <Flex vertical gap="large" className="app-detail-container">
      <Flex vertical gap="small" className="app-detail-header">
        <Button
          type="link"
          icon={<ArrowLeftOutlined />}
          className="app-detail-back-button"
          onClick={onBack}
        >
          {t('detail.backToList', 'Back to Organizations')}
        </Button>

        <Flex justify="space-between" align="center" gap={12} wrap>
          <Typography.Title level={2} className="app-detail-title">
            {t('detail.manageTitle', { name: organization.name })}
          </Typography.Title>
          <Flex gap={8} wrap>
            <TriggerIziviaMonprojetCasesButton
              organizationId={organization.id}
            />
            <TriggerIziviaMonprojetWorkOrdersButton
              organizationId={organization.id}
            />
          </Flex>
        </Flex>

        <Typography.Text type="secondary">
          {t('detail.manageSubtitle')}
        </Typography.Text>
      </Flex>

      <OrganizationTabs
        activeTab={activeTab}
        onTabChange={onTabChange}
        tabList={organizationTabList}
      />

      {activeTab === 'overview' ? (
        <OrganizationOverviewCard organization={organization} />
      ) : null}
      {activeTab === 'managers' ? <ManagersTabPageContainer /> : null}
      {activeTab === 'supervisors' ? <SupervisorsTabPageContainer /> : null}
      {activeTab === 'technicians' ? <TechniciansTabPageContainer /> : null}
      {activeTab === 'parks' ? <ParksTabPageContainer /> : null}
      {activeTab === 'tags' ? <TagsTabPageContainer /> : null}
    </Flex>
  );
}
